export default "__VITE_ASSET__CfYXujV5__"